module.exports = __webpack_public_path__ + "f27b11b8b5b10dde93bf5e599c8a710f.png";